import { z } from 'zod';

// Mirrors CreateFgoMemberSegmentHandler's server-side validation (name length, badgeIds/
// locationFilters shape) -- this schema only constrains what the client sends; the
// authoritative checks (definition non-empty, locationFilters semantics, badge ownership,
// per-fangroup cap) still live server-side.
export const CreateFanGroupMemberSegmentValidatorSchema = z.object({
  name: z.string().min(1).max(120),
  locationFilters: z.array(z.string()).optional(),
  badgeIds: z.array(z.string()).optional(),
  query: z.string().optional(),
});

export type CreateFanGroupMemberSegmentValidator = z.infer<
  typeof CreateFanGroupMemberSegmentValidatorSchema
>;
